// Helper functions for creating curly bracket SVG elements

import config from '../config.json';

/**
 * Creates an SVG path string for a curly bracket between two points
 * @param {number} x1 - Start X coordinate
 * @param {number} y1 - Start Y coordinate  
 * @param {number} x2 - End X coordinate
 * @param {number} y2 - End Y coordinate
 * @param {number} width - Bracket width (default from config)
 * @param {number} expressiveness - Curve factor 0-1 (default: 0.6)
 * @returns {string} SVG path data
 */
export const createCurlyBracketPath = (x1, y1, x2, y2, width = config.visual.intervals.bracketSpacing.curveHeight, expressiveness = 0.6) => {
  const dx = x1 - x2;
  const dy = y1 - y2;
  const len = Math.sqrt(dx*dx + dy*dy);
  const udx = dx / len;
  const udy = dy / len;
  
  const qx1 = x1 + expressiveness * width * udy;
  const qy1 = y1 - expressiveness * width * udx;
  const qx2 = (x1 - 0.25*len*udx) + (1-expressiveness) * width * udy;
  const qy2 = (y1 - 0.25*len*udy) - (1-expressiveness) * width * udx;
  const tx1 = (x1 - 0.5*len*udx) + width * udy;
  const ty1 = (y1 - 0.5*len*udy) - width * udx;
  const qx3 = x2 + expressiveness * width * udy;
  const qy3 = y2 - expressiveness * width * udx;
  const qx4 = (x1 - 0.75*len*udx) + (1-expressiveness) * width * udy;
  const qy4 = (y1 - 0.75*len*udy) - (1-expressiveness) * width * udx;
  
  return `M ${x1} ${y1} Q ${qx1} ${qy1} ${qx2} ${qy2} T ${tx1} ${ty1} M ${x2} ${y2} Q ${qx3} ${qy3} ${qx4} ${qy4} T ${tx1} ${ty1}`;
};

/**
 * Calculates bracket positions between notes
 * @param {Array} notes - VexFlow note objects
 * @param {number} noteWidth - Spacing from note centers (default: 6)
 * @returns {Array} Array of position objects with startX, endX, centerX, intervalValue
 */
export const calculateBracketPositions = (notes, noteWidth = 6) => {
  return notes.slice(0, -1).map((note, index) => {
    const currentX = note.getAbsoluteX();
    const nextX = notes[index + 1].getAbsoluteX();
    const startX = currentX + noteWidth;
    const endX = nextX - noteWidth/2;
    const centerX = (startX + endX) / 2;
    
    return { startX, endX, centerX, intervalValue: index };
  });
};